import '../polyfill/arrayFrom';

const HeroSlider = (() => {
  const DOM = {};
  let options,
    slideWidth,
    slidesLength,
    posInitial,
    index = 0,
    interval,
    allowShift = true;

  function cacheDOM() {
    const { containerClass, sliderClass, nextClass, prevClass, dotsClass } = options;
    DOM.container = document.getElementsByClassName(`${containerClass}`);
    if (DOM.container.length > 0) {
      DOM.slider = document.getElementsByClassName(`${sliderClass}`);
      DOM.slides = Array.from(DOM.slider[0].children);

      DOM.next = document.getElementsByClassName(`${nextClass}`);
      DOM.prev = document.getElementsByClassName(`${prevClass}`);

      DOM.dots = document.getElementsByClassName(`${dotsClass}`);
    }
  }

  const cloneSlide = () => {
    let firstSlide = DOM.slides[0],
        secondSlide = DOM.slides[1],
        lastSlide = DOM.slides[slidesLength - 1];

    let cloneFirst = firstSlide.cloneNode(true);
    let cloneSecond = secondSlide.cloneNode(true);
    let cloneLast = lastSlide.cloneNode(true);

    DOM.slider[0].appendChild(cloneFirst);
    DOM.slider[0].appendChild(cloneSecond);
    DOM.slider[0].insertBefore(cloneLast, firstSlide);

  };

  const setSlidePosition = (slide, index) => {
    slide.style.left = slideWidth * index + 'px';
  };

  const setFirstSlide = () => {
    DOM.slider[0].style.transform = 'translateX(-' + DOM.slides[0].style.left + ')';
    setClass(0);
  };

  const shiftSlide = (dir, action) => {
    DOM.slider[0].classList.add('shifting');

    if (allowShift) {
      if (!action) { posInitial = DOM.slides[index].offsetLeft;}

      if (dir === 1) {
        DOM.slider[0].style.transform = 'translateX(-' + (posInitial + slideWidth) + 'px)';
        index++;
      } else if (dir === -1) {
        DOM.slider[0].style.transform = 'translateX(-' + (posInitial - slideWidth) + 'px)';
        index--;
      }
    }
    setClass(index);
    allowShift = false;
  };

  const moveToSlide = (targetSlide) => {
    DOM.slider[0].classList.add('shifting');

    setClass(targetSlide.dataset.value);

    let slide = parseInt(targetSlide.dataset.value) + 1;

    if (slide === 1) {
      DOM.slider[0].style.transform = 'translateX(-' + (slideWidth) + 'px)';
    } else if (slide > 1) {
      DOM.slider[0].style.transform = 'translateX(-' + (slideWidth * slide) + 'px)';
    }

    index = slide -1;
    allowShift = false;
  };

  const setClass = (targetSlide) => {
    if (targetSlide === DOM.slides.length) {
      targetSlide = 0;
    }

    for (let i = 0; i < DOM.newSlides.length; i++) {
      DOM.newSlides[i].classList.remove('current-slide', 'prev-slide', 'next-slide');
      if (DOM.dots[i]) {
        DOM.dots[i].classList.remove('active');
      }
    }

    // Infinity slider
    DOM.newSlides[DOM.slides.length].classList.add('prev-slide');
    DOM.newSlides[DOM.newSlides.length - 1].classList.add('next-slide');

    DOM.slides[targetSlide].previousElementSibling.classList.add('prev-slide');
    DOM.slides[targetSlide].classList.add('current-slide');
    DOM.slides[targetSlide].nextElementSibling.classList.add('next-slide');

    DOM.dots[targetSlide].classList.add('active');
  };

  const setupSlider = () => {
    slideWidth = DOM.slides[0].offsetWidth;
    slidesLength = DOM.slides.length;

    cloneSlide();

    DOM.newSlides = Array.from(DOM.slider[0].children);
    DOM.newSlides.forEach(setSlidePosition);

    setFirstSlide();

    interval = setInterval(() => {
      shiftSlide(1);
    }, 15000);
  };

  const checkIndex = () => {
    DOM.slider[0].classList.remove('shifting');

    if (index === -1) {
      DOM.slider[0].style.transform = 'translateX(-' + (slideWidth * slidesLength) + 'px)';
      index = slidesLength - 1;
    }

    if (index === slidesLength) {
      DOM.slider[0].style.transform = 'translateX(-' + (1 * slideWidth) + 'px)';
      index = 0;
    }
    allowShift = true;
  };

  function setupEventListeners() {
    if (DOM.next.length > 0) {
      DOM.next[0].addEventListener('click', () => { shiftSlide(1); });

      DOM.prev[0].addEventListener('click', () => { shiftSlide(-1); });
    }

    for (let i = 0; i < DOM.dots.length; i++) {
      DOM.dots[i].addEventListener('click',  (e) => {
        if (allowShift) {
          moveToSlide(e.target);
          clearInterval(interval);
        }
      });
    }

    window.addEventListener("resize", setSlidePosition);

    DOM.slider[0].addEventListener('transitionend', checkIndex);
  }

  function init(customOptions) {
    const defaults = {
      containerClass: 'hero-image__container',
      sliderClass: 'hero-image__slider',
      nextClass: 'hero-image__next',
      prevClass: 'hero-image__prev',
      dotsClass: 'hero-image__nav--dot'
    };

    options = Object.assign(defaults, customOptions);

    cacheDOM();

    if (DOM.container.length > 0) {
      setupSlider();
      setupEventListeners();
    }
  }

  return { init };
})();

export default HeroSlider;
